import { supabase } from '@/lib/supabase';
import type { Campaign } from './types';

export interface BingPeriodReport {
  status: 'ready' | 'pending';
  rows?: Campaign[];
  fetched_at?: string;
}

export async function getBingPeriod(from: string, to: string): Promise<BingPeriodReport> {
  const { data } = await supabase.auth.getSession();
  if (!data.session) throw new Error('Log opnieuw in om Microsoft-rapporten te laden.');
  const response = await fetch(`/oauth/reports/bing?${new URLSearchParams({from,to})}`, {
    headers: { Authorization: `Bearer ${data.session.access_token}` },
  });
  if (!response.ok) throw new Error('Microsoft-periodecijfers konden niet worden geladen.');
  return response.json();
}
